export const COGNITO_CONFIG = {
  REGION: process.env.REACT_APP_REGION,
  USER_POOL_ID: process.env.REACT_APP_USER_POOL_ID,
  APP_CLIENT_ID: process.env.REACT_APP_APP_CLIENT_ID,
};
